import { Modal, Dropdown } from 'bootstrap';
import Popper from "@popperjs/core";

// export const MODAL_TEMPLATE = '<div class="modal-container"><div class="modal fade text-start" id="__ID__" modalId tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-fetch-body></div></div>';

export default (function ( window, document, undefined ) {
  async function fetchUrl(url) {
    const html = await fetch(url)
      .then((response) => response.text());

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    // const update = doc.querySelector('.page-section');

    return doc;
  }

//   document.addEventListener('click', (event) => {
//     const toggle = event.target.closest('[data-bs-toggle]');
//     console.log('Toggle', toggle);
// });

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-bs-target]');
    const id = trigger && trigger.dataset.bsTarget;
    const target = id && document.querySelector(id);

    if (trigger && (!target || !target.childNodes.length)) {
      console.log('Click', trigger, id);
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const url = trigger.dataset.bsUrl;
      console.log('Fetch', url);
      const response = url && await fetchUrl(url);
      document.body.appendChild(response.body.firstElementChild);

      if (!trigger.dataset.bsToggle) {
        trigger.dataset.bsToggle = 'modal';

        trigger.dispatchEvent(new Event('click', {
          bubbles: true,
          cancelable: true
        }));

        window.dispatchEvent(new Event('DOMContentLoaded', {
          bubbles: true,
          cancelable: true
        }));

        window.dispatchEvent(new Event('load', {
          bubbles: true,
          cancelable: true
        }));
      }
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    const modals = Array.from(document.querySelectorAll('.modal'));
    if (modals.length) {
      modals.forEach(modal => {
        modal.addEventListener('show.bs.modal', async (event) => {
          const target = event.relatedTarget;
          const url = target && target.dataset.bsUrl;
          if (url && ! modal.childNodes.length) {
            event.preventDefault();
            event.stopPropagation();
            const response = url && await fetchUrl(url);
            const update = response.querySelector('[data-fetch-body]');
            modal.parentNode.replaceChild(update, modal);
            const newModal = new Modal(update);
            newModal.show();

            window.dispatchEvent(new Event('DOMContentLoaded', {
              bubbles: true,
              cancelable: true
            }));

            window.dispatchEvent(new Event('load', {
              bubbles: true,
              cancelable: true
            }));
          }
          else {
            const modalContent = modal.querySelector('.modal-content');
            const elements = modalContent && modalContent.querySelectorAll('[id]');
            const form = modalContent && modalContent.querySelector('form');
            const formId = form && form.id || form.name;

            [ ...elements ].forEach(element => {
                const id = `${formId}-${element.id}`;
                const labels = elements && modalContent.querySelectorAll(`[for=${element.id}]`);
                [ ...labels ].forEach(label => {
                    label.setAttribute('for', id)
                });
                element.id = id;
            });
            // console.log('update', elements);
          }
        })
      });
    }
  });
})( window, document );

